const team = [
  {
    name: 'VictorGrace Kabamba',
    role: 'Directeur Général',
    description: 'Ingénieur en construction',
    image: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/ce52890f59aa7f372f5397f0893a5593.jpeg',
    linkedin: '#'
  },
  {
    name: 'Patrick Kaboba',
    role: 'Architecte en chef',
    description: 'Expert en conception architecturale et gestion de projets',
    image: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/fca94e016127215555151963018bd242.jpeg',
    linkedin: '#'
  },
  {
    name: 'Harwick Mechack Kayembe Bambe',
    role: 'Ir civil en bâtiment et travaux publics',
    description: 'Spécialiste en génie civil et infrastructures',
    image: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/32d2541a261cc4bcb2727dd9f4620ba8.jpeg',
    linkedin: '#'
  },
  {
    name: 'Simon Tshimpangila',
    role: 'Ingénieur IT',
    description: 'Expert en solutions technologiques et systèmes d\'information',
    image: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/5301b49f3d3c28165f780d476fc0dd8a.jpeg',
    linkedin: '#'
  },
  {
    name: 'Mulenda Kongolo Nathan',
    role: 'Architecte',
    description: 'Créatif et passionné par la conception d\'espaces innovants',
    image: 'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/cdada1ea20d929e37fd0bdad4525a722.jpeg',
    linkedin: '#'
  }
];

const TeamSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Notre Équipe</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des professionnels passionnés et expérimentés à votre service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="relative h-96 overflow-hidden bg-gray-100">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  style={{ objectPosition: 'center 20%' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <div className="text-blue-600 font-semibold mb-3">{member.role}</div>
                <p className="text-gray-600 leading-relaxed mb-4">{member.description}</p>
                <a
                  href={member.linkedin}
                  className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                >
                  <i className="ri-linkedin-box-fill text-xl mr-2"></i>
                  LinkedIn
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
